import type { DashboardSummary } from '../../dashboard/hooks.js';

/**
 * Demo dashboard summary — a plausible mid-size customer (one
 * organization, three teams, ~30 scenarios, ~15 KPI types). Numbers
 * are deliberately round so the live-vs-demo swap reads clearly to
 * the operator showing the demo.
 */
export const DEMO_DASHBOARD_SUMMARY: DashboardSummary = {
  licenseId: 'demo-license',
  orgsCount: 1,
  // 5 teams (Operations, Engineering, Customer Success, Finance,
  // People & HR) — matches the teams referenced by the 30 demo
  // scenarios in `./scenarios.ts`.
  teamsCount: 5,
  // 30 scenarios per the expanded fixture (operator-reported pre-
  // expansion: "8 scenarios is small amount, need ~30").
  scenariosCount: 30,
  // 5 KPI types (execution health / throughput / customer impact /
  // cost / compliance) per `./kpi.ts`.
  kpiTypesCount: 5,
  fetchedAt: new Date().toISOString(),
};
